<template>
 <div class="mask">
    <section class="mod-explain-pop">
    <div class="title">赠片特权更新告知</div>
    <div class="content">
      赠片送好友特权已经进行优化升级，新版赠片支持灵活调整赠送份数，并新增分享海报图能力，让赠送体验更沉浸，快去选片赠送给好友吧~
    </div>
    <button class="btn" @click="goGradePage">前往查看</button>
 </section>
 </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    goGradePage () {
      location.href = 'https://film.qq.com/x/autovue/privilege/route/detail?title=%E8%B5%A0%E7%89%87%E9%80%81%E5%A5%BD%E5%8F%8B'
    }
  }
}
</script>
<style lang="scss">
.mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 999;
}
.mod-explain-pop{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 304px;
    padding: 20px 16px;
    background:#fff;
    border-radius: 12px;
    color: #000028;
    .title{
        font-size: 17px;
        font-weight: 600;
        text-align: center;
    }
    .content{
      font-size: 15px;
      margin: 20px 0;
    }
    .btn{
        width: 100%;
        height: 44px;
        font-weight: 500;
        border-radius: 22px;
        font-size: 14px;
        color: #663d00;
        border: 0;
        outline: 0;
        background-image: linear-gradient(269deg, #f2ca5b 0%, #ffdf89 100%);
    }
}

</style>
